import { useEffect, useState } from "react";
import MeetingRequestForm from "./MeetingRequestForm";
import { decryptData } from "../../utils/decrypt";
import axios from "axios";

interface Agenda {
  agendaId: number;
  title: string;
  mail: boolean;
  createdAt: string;
  updatedAt: string;
}

const MeetingRequest = () => {
  const [agendas, setAgendas] = useState<Agenda[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [showThankYou, setShowThankYou] = useState(false);

useEffect(() => {
  const fetchAgendas = async () => {
    try {
      const response: any = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/agenda`
      );

      const encryptedData = response.data.data;
      const iv = response.data.iv;

      const decrypted = decryptData({ data: encryptedData }, iv);

      console.log(decrypted);

      setAgendas(decrypted);

    } catch (err) {
      console.log("error is ", err);
      setError("Failed to fetch agendas.");
    }
  };

  fetchAgendas();
}, []);

  if (error) {
    return (
      <div className="text-center text-red-500 text-lg mt-10">
        {error}
      </div>
    );
  }

  return (
    <div className="px-6 md:px-12 lg:px-20 flex justify-center mt-13">
      {showThankYou ? (
        <div className="flex flex-col items-center justify-center text-center h-[70vh] gap-4">
          <h1 className="font-heading text-[60px] text-[#222222]">
            Thank you
          </h1>
          <p className="text-[26px] font-heading text-[#222222]">
            for contacting us. We will get back to you soon.
          </p>
        </div>
      ) : (
        <div className="flex flex-col md:flex-row gap-5 w-full max-w-[1200px] items-start">
          <h3 className="font-heading text-[42px] md:text-[50px] text-[#222222] leading-tight" style={{fontSize:"45px"}}>
            Meeting request
          </h3>
          <MeetingRequestForm
            agendas={agendas ?? []}
            onFormSubmit={() => setShowThankYou(true)}
          />
        </div>
      )}
    </div>
  );
};

export default MeetingRequest;
